export default "__VITE_ASSET__CcXcx5g3__"